import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import * as moment from 'moment';
import { map, Observable, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ClientService {
  constructor(private firestore: AngularFirestore) {}

  getClients(): Observable<any[]> {
    return this.firestore
      .collection('clientProfile')
      .snapshotChanges()
      .pipe(
        take(1),
        map((data) =>
          data
            .map((e) => {
              const obj: any = e.payload.doc.data();
              obj.userUID = e.payload.doc.id;
              obj.firstName = `${obj.firstName} ${obj.lastName}`;
              return this.transformDates(obj);
            })
            .sort(
              (a, b) =>
                Number(new Date(b.packageStartDate)) -
                Number(new Date(a.packageStartDate))
            )
        )
      );
  }

  private transformDates(data: any): any {
    const format = (d: any) =>
      moment(d ? d.toDate?.() || d : d).format('DD/MM/YYYY');

    return {
      ...data,
      amntReceivedDate: format(data.amntReceivedDate),
      amntRemainingDate: format(data.amntRemainingDate),
      packageStartDate: format(data.packageStartDate),
      packageEndDate: format(data.packageEndDate),
    };
  }
}
